import { useWidgetConfig } from '@/context/WidgetConfigContext';

export const Login = () => {
  const { storefrontLoginURL } = useWidgetConfig();

  return (
    <div className='flex h-full flex-col items-center justify-center gap-2 space-y-4 text-center'>
      <h5>Please log in to continue.</h5>
      <a href={storefrontLoginURL} className='transform-none rounded-md text-[14px]'>
        Go to Login
      </a>
    </div>
  );
};
